module.exports = __webpack_public_path__ + "static/media/klub-only-logo.50b875a3.png";